/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_BLOCK_CHAIN_PROOF: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.getBlockchainProof',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_BLOCK_CHAIN_PROOF' },
      },
    },
    GET_BLOCK_CHAIN_PROOF: {
      invoke: {
        id: 'getBlockchainProof',
        src: 'getBlockchainProof',
        onDone: {
          target: 'GET_BLOCK_CHAIN_PROOF_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_BLOCK_CHAIN_PROOF_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    GET_BLOCK_CHAIN_PROOF_SUCCESS: {
      on: {
        START: { target: 'GET_BLOCK_CHAIN_PROOF' },
      },
    },
    GET_BLOCK_CHAIN_PROOF_ERROR: {
      on: {
        START: { target: 'GET_BLOCK_CHAIN_PROOF' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
